import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "value", "getLabel", "as"];
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import React from 'react';
import i18n from 'i18next';
import getDuration from './getDuration';
function zeroPad(number) {
  if (number < 10) {
    return String(number).padStart(2, '0');
  } else return number;
}
function getDefaultLabel(minutes, hours) {
  if (hours) {
    return "".concat(i18n.t('hour', {
      count: hours
    }), ", ").concat(i18n.t('minute', {
      count: minutes
    }));
  } else return i18n.t('minute', {
    count: minutes
  });
}
function getDefaultChildren(duration) {
  var hours = duration.hours,
    minutes = duration.minutes,
    seconds = duration.seconds;
  var durationFragments = hours ? [hours, zeroPad(minutes), zeroPad(seconds)] : [minutes, zeroPad(seconds)];
  return durationFragments.join(':');
}
function Duration(props) {
  var _props$children = props.children,
    children = _props$children === void 0 ? getDefaultChildren : _props$children,
    _props$value = props.value,
    value = _props$value === void 0 ? 0 : _props$value,
    _props$getLabel = props.getLabel,
    getLabel = _props$getLabel === void 0 ? getDefaultLabel : _props$getLabel,
    _props$as = props.as,
    Component = _props$as === void 0 ? 'span' : _props$as,
    otherProps = _objectWithoutProperties(props, _excluded);
  var duration = getDuration(value);
  return /*#__PURE__*/React.createElement(Component, _extends({}, otherProps, {
    "aria-label": getLabel(duration.minutes, duration.hours)
  }), children(duration));
}
export { getDuration };
export default Duration;